import { ModelSerializer, modelSerializer } from '@housekeep/infra';

import { HelpCategoryDefinition, helpCategoryDefinition } from 'models/help-category';

export const helpCategoryDefinitionSerializer = modelSerializer.extend({
  model: helpCategoryDefinition
}) as ModelSerializer<HelpCategoryDefinition>;
